/*import React from 'react'; */
import { Mail } from 'lucide-react';

export default function NewsletterPage() {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-lg shadow-xl overflow-hidden">
          <div className="px-6 py-8 sm:p-10">
            <div className="text-center">
              <Mail className="mx-auto h-12 w-12 text-indigo-600" />
              <h2 className="mt-4 text-3xl font-extrabold text-gray-900">
                Subscribe to Our Newsletter
              </h2>
              <p className="mt-4 text-lg text-gray-600">
                Get the latest tech insights and updates delivered to your inbox weekly.
              </p>
            </div>

            <form className="mt-8">
              <div className="space-y-4">
                <div>
                  <label htmlFor="email" className="sr-only">
                    Email address
                  </label>
                  <input
                    id="email"
                    name="email"
                    type="email"
                    required
                    className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm px-4 py-3"
                    placeholder="Enter your email"
                  />
                </div>
                <div className="flex items-center">
                  <input
                    id="preferences"
                    name="preferences"
                    type="checkbox"
                    className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
                  />
                  <label htmlFor="preferences" className="ml-2 block text-sm text-gray-600">
                    I want to receive updates about new articles and podcasts
                  </label>
                </div>
                <button
                  type="submit"
                  className="w-full flex justify-center py-3 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                >
                  Subscribe Now
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}